import Tab from './Tabs';
import Titles from './Titles';
import Contents from './Contents';

export const Tabs = { Tab, Titles, Contents };
